module.exports = function() {
  return new Worker(__webpack_public_path__ + "0c27d7837f8ca2a0c062.worker.js");
};